import { styled } from 'styled-system/jsx'

const DotsRow = styled('div', {
  base: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    justifyContent: 'center',
  },
})

const Dot = styled('div', {
  base: {
    height: '8px',
    borderRadius: 'pill',
    transition:
      'width {durations.standard} {easings.appleStandard}, background-color {durations.standard} {easings.appleStandard}',
  },
  variants: {
    state: {
      complete: {
        width: '8px',
        backgroundColor: 'quickpass.primary',
      },
      current: {
        width: '28px',
        backgroundColor: 'quickpass.primary',
      },
      upcoming: {
        width: '8px',
        backgroundColor: '#E5E0F5',
      },
    },
  },
  defaultVariants: {
    state: 'upcoming',
  },
})

export { DotsRow, Dot }
